import { render, staticRenderFns } from "./ChangePlan.vue?vue&type=template&id=1bded900&scoped=true&"
import script from "./ChangePlan.vue?vue&type=script&lang=js&"
export * from "./ChangePlan.vue?vue&type=script&lang=js&"
import style0 from "./ChangePlan.vue?vue&type=style&index=0&id=1bded900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bded900",
  null
  
)

export default component.exports